






























import {Component, Watch} from "vue-property-decorator";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {CommonStatus} from "@/enums/status";
import {PartnerStore} from "@/modules/partners/store";
import debounce from "lodash/debounce";
import {PartnerParams} from "@/modules/partners";
import {PartnerType} from "@/enums/type";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";

@Component({
    name: "PartnerSearch",
    components: {PostOfficeSelector, EnumSelector}
})
export default class extends mixins(CommonMixin) {
    CommonStatus = CommonStatus;
    PartnerType = PartnerType;
    form = new PartnerParams();

    @Watch('form', {immediate: false, deep: true})
    onValuesChange(val: any) {
        this.handleChange(val);
    }

    handleChange = debounce(function (val) {
        const params = {...val, page: 1};
        PartnerStore.updatePartnerParams(params);
        PartnerStore.listPartner({params, refresh: true});
    }, 500);
}
